<template>
  <div class="sub-page">
    <!-- 破纪录 -->
    <div class="header-break">
      <div class="type-box">
        <div class="item-name" @click="selectType(index)" :class="typeIndex==index?'active':''" v-for="(item,index) in typeList" :key="item.id">按比赛项目</div>
      </div>
      <div class="program-box">
        <div class="program">项目 <a-divider type="vertical" /> </div>
        <div class="program " v-for="(item,index) in projectList" :key="item.id" :class="index==projectIndex?'active':''" @click="selectProject(item,index)">{{item.name}}</div>
      </div>
    </div>
    <div class="card-box">
      <a-collapse v-model="activeKey" :expand-icon-position="'right'">
        <!-- <a-collapse-panel key="1" header="射击" :style="{background: activeKey.indexOf('1') > -1 ? '#009EDF' : '#c9cbcc'}">
          <div class="item-box">
            <p>少年乙组-男子25米手枪速射（8'30+30）（个人赛）</p>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
          </div>
          <div class="item-box">
            <p>少年乙组-男子25米手枪速射（8'30+30）（个人赛）</p>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
          </div>
          <p slot="extra">
            破市最高：4 <a-divider type="vertical" /> 
            破市记录：10<a-divider type="vertical" /> 
            破市乙组：2<a-divider type="vertical" /> 
            合计：20
          </p>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="田径" :style="{background: activeKey.indexOf('2') > -1 ? '#009EDF' : '#c9cbcc'}">
          <div class="item-box">
            <p>少年乙组-男子25米手枪速射（8'30+30）（个人赛）</p>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
          </div>
          <div class="item-box">
            <p>少年乙组-男子25米手枪速射（8'30+30）（个人赛）</p>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
          </div>
          <p slot="extra">
            破市最高：4 <a-divider type="vertical" /> 
            破市记录：10<a-divider type="vertical" /> 
            破市乙组：2<a-divider type="vertical" /> 
            合计：20
          </p>
        </a-collapse-panel> -->
      </a-collapse>
      <a-empty class="empty">
        <span slot="description">暂无数据</span>
      </a-empty>
    </div>
  </div>
</template>

<script>
export default {
  name:'RecordBreaking',
  props:{ 
  },
  data () {
    return {
      activeKey: ['1'],
      typeList:[
        {id:-1,name:'按比赛项目',staus:0},
        {id:2,name:'按记录类型',staus:0},
      ],
      projectList:[
        {id:-1,name:'全部',staus:0},
        {id:2,name:'射击',staus:0},
        {id:3,name:'田径',staus:0},
        {id:4,name:'游泳',staus:0},
      ],
      projectIndex:0,
      typeIndex:0,
    }
  },
  watch: {
    activeKey (key) {
      console.log(key)
    },
  },
  methods: {
    selectProject (item,index){
      this.projectIndex = index
      console.log(item)

    },
    selectType (index){
      this.typeIndex = index

    }
  },
}
</script>

<style lang="scss" scoped>
.sub-page{
  border-top: 1px solid #E4E4E4;
  padding-top: 30px;
  background-color: #FBFBFB;
  margin-bottom: 30px;
}
.header-break{
  width:1200px;
  border-radius:10px;
  background: white;
  height: 120px;
  box-shadow: 0 0px 4px 4px rgba(0,0,0,0.03);

  margin: 0 auto;
  .type-box{
    width: 100%;
    height: 60px;
    .item-name{
      width: 140px;
      background: rgb(189, 188, 188);
      height: 40px;
      text-align: center;
      float: left;
      line-height: 40px;
      color: white;
      margin: 20px 0px 10px 20px;
      cursor: pointer;
    }
    .item-name:hover{
      opacity: 0.8;
    }
    .active{
      background: #009EDF;
    }
  }
  
  .program-box{
    width: 100%;
    padding-left: 20px;
    height: 40px;
    margin-top: 10px;
    .program{
      float: left;
      width: 80px;
      text-align: center;
      height: 36px;
      line-height: 36px;
      cursor: pointer;

    }
     .program:hover{
      opacity: 0.8;
     }
    .active{
      background: #009EDF;
      color: white;
    }
  }
}
.card-box{
  width: 1200px;
  border-radius:10px;
  background: white;
  box-shadow: 0 0px 4px 4px rgba(0,0,0,0.03);
  margin: 10px auto;
  padding: 20px;
  .ant-collapse /deep/ {
    background-color: #c9cbcc;
    border: none;
    .ant-collapse-header{
      color: white;
    }
    .ant-collapse-content{
      width: 100%;
    }
    .ant-collapse-item{
      border: none;
    }
  }
  .item-box{
    margin-top: 10px;
    overflow: hidden;
  }
  .item-card{
    width: 30%;
    height: 150px;
    background: -webkit-linear-gradient(#FFDFA8, #FFD297,#E1B171); 
    background: -o-linear-gradient(#FFDFA8, #FFD297,#E1B171); 
    background: -moz-linear-gradient(#FFDFA8, #FFD297,#E1B171); 
    background: linear-gradient(#FFDFA8, #FFD297,#E1B171); 
    border-radius:10px ;
    padding: 2% 2%;
    position: relative;
    float: left;
    margin-right: 3.3%;
    .score{
      height: 50px;
      background: white;
      width: 100%;
      border-radius:5px;
      line-height: 50px;
      padding-left: 10px;
      margin-bottom: 10px;
    }
    .pos-icon{
      width: 80px;
      text-align: center;
      line-height: 30px;
      height: 30px;
      background: #124584;
      color: white;
      border-radius: 0 10px 0px 10px;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .empty{
        min-height: 400px;
        padding-top: 100px;
    }
}
</style>


// WEBPACK FOOTER //
// src/district/views/schedule/components/RecordBreaking.vue